export default __webpack_public_path__ + "static/media/m-KOL.8dfaccb2.png";